import { render, staticRenderFns } from "./index.vue?vue&type=template&id=236741c9"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('236741c9')) {
      api.createRecord('236741c9', component.options)
    } else {
      api.reload('236741c9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=236741c9", function () {
      api.rerender('236741c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/agency/promotionalPlansManagement/index.vue"
export default component.exports